import { ICreateAfastamentoUseCase } from "../../../presentation/useCases/create/create_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * CreateAfastamentoUseCase
 */

export class CreateAfastamentoUseCase implements ICreateAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async createAfastamento(
    idFuncionario: number,
    idMotivoAfastamento: number,
    dataInicio: Date,
    dataTermino: Date,
    observacao: string,
  ): Promise<void> {
    await this.repository.createAfastamento(
      idFuncionario,
      idMotivoAfastamento,
      observacao,
      dataInicio,
      dataTermino,
    );
  }
}